import React from "react";
import { STORAGE_ASSETS } from "../../Const/BaseUrlConst";

type DownProps = React.HTMLAttributes<HTMLDivElement> & {};

export const Down: React.FC<DownProps> = ({ ...props }) => {
  return (
    <div {...props}>
      <img src={STORAGE_ASSETS+"/images/svg/down.svg"} alt="" />
    </div>
  );
}; 